import { createAction, props } from '@ngrx/store'
import { Chart } from '../models/chart.model'

export const loadChartSuccess = createAction(
  '[Chart] Load Chart success',
  props<{ chart: Chart }>()
)
export const loadChartFailure = createAction('[Chart] Load Chart failure', props<{ error: any }>())
